<template>
  <div>
    <div v-if="ready">
      <s-table
        xkey="contactData.id"
        :topOffset="190"
        :mobileMode="true"
        v-if="contactData || customReq"
        heightWish="90%"
        :pagging="50"
        v-model="nots"
        :colDefinitions="colDefinitions"
        modx-processor="notifications/getlist"
        :r-query="qNotifications"
      ></s-table>
    </div>
    <h5 v-else><br /><br /><br />loading...</h5>
  </div>
</template>

<script>
import _ from "lodash";
import * as api from "~/api/resource";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "message-list",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    customReq: {
      type: Object,
      default: () => null,
    },
    contactData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      nots: null,
      ready: false,
      messages: [],
      userProfile: UserProfile,
      dateFormat: "DD/MM/YY",
    };
  },
  watch: {
    // transactions: {
    //   handler(val) {
    //     _log_(">>Q>>>",val, this.qTransactions);
    //     if (val && val.length) {
    //       const vm = this;
    //       vm.$emit("transctionsChanged", vm.transactions);
    //     }
    //   },
    //   deep: true
    // },
    async "contactData.id"(val, oldvl) {
      if (val == oldvl) return;
      const vm = this;
    },
    // async businessId(newVal, oldVal) {
    //   if (newVal != oldVal) {
    //     var { data } = await api.fetchProcessor("business/get", {
    //       objectId: this.invoiceData.businessId
    //     });
    //     this.businessData = data.object;
    //     // this.selectedBusiness = JSON.parse(JSON.stringify(data.object));
    //   }
    // }
  },
  computed: {
    qNotifications() {
      // _log_(">>> this.customReq.id>>", this.customReq);
      if (this.customReq) return this.customReq;
      _log_(">>>contactData.id>>", this.contactData.id);
      return { contact_id: this.contactData.id };
    },
    colDefinitions() {
      const vm = this;

      return [
        {
          prop: "timeSent",
          width: "120px",

          label: "Αποστολή",
          formatter(val, colDefs, row) {
            return val > 100 ? vm.formatUnxTime(val) : null;
          },
        },
        {
          prop: "timeInteracted",
          width: "120px",

          label: "Το είδε",
          formatter(val, colDefs, row) {
            return val > 100 ? vm.formatUnxTime(val) : null;
          },
        },
        {
          prop: "route_flight",
          width: "120px",
          formatter(val, colDefs, row) {
            if (!val) return;
            return (row.route_details ? row.route_details + ":" : "") + val;
          },
          label: "Δρομολογιο",
        },
        {
          prop: "route_date",
          width: "120px",
          formatter(val, colDefs, row) {
            if (!val) return;
            return (
              vm.formatUnxTime(val, false, true) +
              ":" +
              vm.intToTime(row.route_startTimeMM)
            );
          },
          label: "Ημρ.Δρλ.",
        },
        {
          prop: "message",
          width: "",

          label: "Μήνυμα",
          formatter(val, colDefs, row) {
            return val;
          },
        },
      ];
    },
    ...mapGetters({
      transactionConfiguration: "user/transactionConfiguration",
    }),
  },
  mounted() {
    this.ready = true;
  },
  methods: {
    init() {},
    removeTrans(e) {
      _log_("trans.ss.go ii..", e);
      if (!this.disabled && e.column.property == "transactionId") {
        if (!e.row.transactionId) return;
        api.removeObject("transaction", { objectId: e.row.transactionId });
        this.removeArrayElement(this.transactions, e.row, "transactionId");
      }
    },
    async handleTransaction(e, forceVAT) {
      _log_("trans.ss.A.." + e.prop + " .. ", e, this.transactions);
      e.row.timologioId = this.invoiceData.timologioId;
      var validVAT = forceVAT;
      if (forceVAT) e.row.vat = forceVAT;
      else
        validVAT =
          parseFloat(e.row.vat ? e.row.vat : this.invoiceData.vat) / 100;

      if (!e.row.quantity) e.row.quantity = 1;
      if (e.prop == "unitcost" || e.prop == "quantity") {
        e.row.cost = parseFloat(e.row.unitcost) * parseFloat(e.row.quantity);
        e.row.costincl = parseFloat(e.row.cost) * (1 + validVAT);
      }
      if (e.prop == "costincl") {
        e.row.cost = parseFloat(e.row.costincl) / (1 + validVAT);
        e.row.unitcost = e.row.cost / e.row.quantity;
      }
      if (e.prop == "cost") {
        e.row.costincl = parseFloat(e.row.cost) * (1 + validVAT);
        // e.row.unit = 1;
        e.row.unitcost = e.row.cost / e.row.quantity;
      }
      var transIndex = null;
      if (e.row.transactionId)
        transIndex = _.findIndex(this.transactions, {
          transactionId: e.row.transactionId,
        });
      else
        transIndex = _.findIndex(this.transactions, function (o) {
          return !o.transactionId;
        });

      //this is handled in the server
      delete e.row.usergroupId;
      delete e.row.userId;
      delete e.row.teamId;
      if (!e.row.cost) e.row.cost = 0;
      if (!e.row.vat && this.invoiceData.vat) e.row.vat = this.invoiceData.vat;
      if (!e.row.unitcost) e.row.unitcost = 0;
      if (!e.row.costincl) e.row.costincl = 0;
      var { data } = await api.fetchProcessor("transaction/update", e.row);

      if (!data.object.cost) data.object.cost = "";

      if (!data.object.costincl) data.object.costincl = "";

      data.object[e.prop] = this.transactions[transIndex][e.prop]; //handles delay
      this.$set(this.transactions, transIndex, data.object);
      // this.$emit("transctionChanged", data.object)
      _log_("trans.ss.BB..", this.transactions);
    },
    handleTransctions(e) {
      // _log_("trans..B..", e);
    },
  },
};
</script>
